exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prepaidCard{background-image:linear-gradient(108deg,#025d91 17.3%,#009cde 77.6%)!important;border:1 17.3% solid #025d91;color:#fff}", ""]);

// exports
